import "./details.js";
import "./orderPackaging.js";


// WEBPACK FOOTER //
// ./src/pages/orderpackaging/index.js